export enum WarningLevel {
  None = "none",
  Info = "info",
  Warning = "warning",
  Danger = "danger",
}
